import React, { useEffect, useState } from "react";
import { Form, Input, Select, Upload, Button, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import axios from "axios";
import AOS from "aos";
// import "aos/dist/aos.css";
// import "antd/dist/antd.css";

const { Option } = Select;
const { TextArea } = Input;

const ContactUs = () => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    userType: "",
    name: "",
    email: "",
    phone: "",
    companyName: "",
    serviceOfInterest: "",
    message: "",
    resume: null,
    coverLetter: "",
    linkedinProfile: "",
    portfolio: "",
    yearsOfExperience: "",
    keySkills: "",
    education: "",
    availability: "",
  });

  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileList, setFileList] = useState([]);
  // Handle file changes (upload/delete)
  const handleFileChange = (info) => {
    let newFileList = [...info.fileList];

    // Limit to only 1 file by keeping the latest one
    newFileList = newFileList.slice(-1);

    // File type validation
    newFileList = newFileList.filter((file) => {
      const isValidType = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file.type);

      if (!isValidType && file.status !== "error") {
        message.error(
          `${file.name} is not a valid file type. Please upload PDF or DOC/DOCX files.`
        );
        return false;
      }

      // File size validation (10MB limit)
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M && file.status !== "error") {
        message.error("File must be smaller than 10MB!");
        return false;
      }

      return true;
    });

    setFileList(newFileList);

    // Important: Update form field value
    form.setFieldsValue({ resume: newFileList });
  };

  // Normalize file value for form
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList || [];
  };

  // Custom upload button
  const uploadButton = <Button icon={<UploadOutlined />}>Upload Resume</Button>;
  const services = [
    "IT Consulting & Solutions",
    "Business Consulting",
    "Tailored Talent Solutions",
  ];

  const availabilityOptions = [
    "Immediately",
    "15-30 days",
    "30-60 days",
    "More than 60 days",
  ];

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      let response;
      const isClient = values.userType === "client";

      if (isClient) {
        // Direct JSON POST for client type
        response = await axios.post("/user/mail", values);
      } else {
        // Create and populate FormData for careers type
        const formData = new FormData();

        Object.keys(values).forEach((key) => {
          if (key === "resume" && values[key]) {
            const file = values[key][0]?.originFileObj;
            if (file) {
              formData.append("resume", file);
            }
          } else {
            // Set fallback values for optional fields
            const fallbackFields = [
              "linkedinProfile",
              "portfolio",
              "coverLetter",
            ];
            const value =
              values[key] || (fallbackFields.includes(key) ? "NA" : "");
            formData.append(key, value);
          }
        });

        // Send formData to careers endpoint
        response = await axios.post("/user/contactus", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentage =
              (progressEvent.loaded * 100) / progressEvent.total;
            setUploadProgress(Math.round(percentage));
          },
        });
      }

      // Success flow
      if (response) {
        toast.success("Form submitted successfully!!", { autoClose: 3000 });
        form.resetFields();
        setFileList([]);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  const contactInfo = [
    {
      title: "Visit Our Office",
      description:
        "Unit 12, Building B0051, Road 0402, AL Qaryah 0604, Capital Governorate, Kingdom of Bahrain.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="bg-black"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
    },
    {
      title: "Let's Talk",
      description: "+966 55 030 0850",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
    },
    {
      title: "Email Us",
      description: "contact@SoloSource.com",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
    },
  ];
  const uploadStyles = {
    ".ant-upload-list": {
      color: "white",
    },
    ".ant-upload-list-item": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderRadius: "4px",
      padding: "4px 8px",
      marginBottom: "8px",
    },
    ".ant-upload-list-item-name": {
      color: "white",
    },
    ".ant-upload-list-item-card-actions": {
      position: "relative",
      top: "0",
    },
  };

  useEffect(() => {
    AOS.init();
  }, []);
  const validationRules = {
    name: [
      { required: true, message: "Enter your name" },
      {
        pattern: /^[A-Za-z\s'-]{2,}$/,
        message: "Must be at least 2 characters. Only letters, spaces allowed",
      },
    ],
    companyName: [
      { required: true, message: "Please enter your last name" },
      {
        pattern: /^[A-Za-z\s'-]{2,}$/,
        message: "Must be at least 2 characters. Only letters, spaces allowed",
      },
    ],
    email: [
      { required: true, message: "Please enter your email" },
      { type: "email", message: "Please enter a valid email" },
    ],
    phone: [
      { required: true, message: "Enter phone number" },
      {
        pattern: /^\d{6,15}$/,
        message: "Phone number must be 6 to 15 digits long as per your country",
      },
    ],
    yearsOfExperience: [
      { required: true, message: "Please select your experience" },
    ],
    resume: [{ required: true, message: "Please upload your resume" }],
    countryCode: [
      { required: true, message: "Enter country code" },
      { pattern: /^\+\d+$/, message: "Valid format: +1, +966, etc." },
    ],
  };
  return (
    <div className="bg-gradient-to-b from-[#6764AD] via-[#915BA6] to-[#202020] overflow-hidden">
      {/* Hero Section */}
      <section className="relative h-[40vh] bg-gradient-to-b from-[#6764AD] via-[#915BA6] to-[#202020]">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl" data-aos="fade-up">
            <h1 className="text-5xl font-bold mb-4">Get in Touch</h1>
            <p className="text-xl text-gray-300">
              We'd love to hear from you. Let's build something amazing
              together.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 -mt-32">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-black p-3 rounded-full text-white">
                    {info.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {info.title}
                    </h3>
                    <p className="text-gray-600">{info.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form & Map Section */}
      <section className="pb-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-10">
            <div
              data-aos="fade-right"
              className="border border-white p-1 bg-white rounded-md"
            >
              <div className="h-full border border-white p-6 bg-black rounded-md">
                <h2 className="text-3xl font-bold text-white mb-8">
                  Send us a Message
                </h2>

                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  requiredMark={false}
                >
                  <Form.Item
                    name="userType"
                    label={
                      <span className="text-white">
                        <span className="text-red-500">*</span> I am a
                      </span>
                    }
                    rules={[
                      { required: true, message: "Please select user type" },
                    ]}
                  >
                    <Select placeholder="Select Type">
                      <Option value="client">Client</Option>
                      <Option value="jobSeeker">Job Seeker</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item noStyle dependencies={["userType"]}>
                    {({ getFieldValue }) => {
                      const userType = getFieldValue("userType");

                      if (userType === "client") {
                        return (
                          <>
                            <div className="grid md:grid-cols-2 gap-6">
                              <Form.Item
                                name="name"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">* </span> Full Name
                                  </span>
                                }
                                rules={validationRules.name}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="companyName"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Company Name
                                  </span>
                                }
                                rules={validationRules.companyName}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                              <Form.Item
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Email
                                  </span>
                                }
                                name="email"
                                rules={validationRules.email}
                              >
                                <Input placeholder="Enter your email address" />
                              </Form.Item>

                              <div className="grid grid-cols-7 gap-1">
                                <Form.Item
                                  label={
                                    <label className="text-white text-[13px]">
                                      <span className="text-red-500">*</span>{" "}
                                      Country Code
                                    </label>
                                  }
                                  name="countryCode"
                                  className="col-span-3"
                                  rules={validationRules.countryCode}
                                >
                                  <Input
                                    placeholder="+966"
                                    maxLength={5}
                                    onKeyPress={(e) => {
                                      if (!/[+\d]/.test(e.key))
                                        e.preventDefault();
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  label={
                                    <span className="text-white">
                                      <span className="text-red-500">*</span>{" "}
                                      Phone Number
                                    </span>
                                  }
                                  name="phone"
                                  className="col-span-4"
                                  rules={validationRules.phone}
                                >
                                  <Input
                                    placeholder="Enter your phone number"
                                    maxLength={15}
                                    onKeyPress={(e) => {
                                      if (!/\d/.test(e.key)) e.preventDefault();
                                    }}
                                  />
                                </Form.Item>
                              </div>
                            </div>

                            <Form.Item
                              name="serviceOfInterest"
                              label={
                                <span className="text-white">
                                  <span className="text-red-500">*</span>{" "}
                                  Service of Interest
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a service",
                                },
                              ]}
                            >
                              <Select placeholder="Select Service">
                                {services.map((service) => (
                                  <Option key={service} value={service}>
                                    {service}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="message"
                              label={
                                <span className="text-white">
                                  <span className="text-red-500">*</span>{" "}
                                  Message
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter your message",
                                },
                              ]}
                            >
                              <TextArea rows={4} />
                            </Form.Item>
                          </>
                        );
                      }

                      if (userType === "jobSeeker") {
                        return (
                          <>
                            <div className="grid md:grid-cols-2 gap-6">
                              <Form.Item
                                name="name"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span> Full Name
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter your name",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="email"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Email Address
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter your email",
                                  },
                                  {
                                    type: "email",
                                    message: "Please enter a valid email",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div className="grid grid-cols-7 gap-1">
                                <Form.Item
                                  label={
                                    <label className="text-white text-[13px]">
                                      <span className="text-red-500">*</span>{" "}
                                      Country Code
                                    </label>
                                  }
                                  name="countryCode"
                                  className="col-span-3"
                                  rules={validationRules.countryCode}
                                >
                                  <Input
                                    placeholder="+966"
                                    maxLength={5}
                                    onKeyPress={(e) => {
                                      if (!/[+\d]/.test(e.key))
                                        e.preventDefault();
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  label={
                                    <span className="text-white">
                                      <span className="text-red-500">*</span>{" "}
                                      Phone Number
                                    </span>
                                  }
                                  name="phone"
                                  className="col-span-4"
                                  rules={validationRules.phone}
                                >
                                  <Input
                                    placeholder="Enter your phone number"
                                    maxLength={15}
                                    onKeyPress={(e) => {
                                      if (!/\d/.test(e.key)) e.preventDefault();
                                    }}
                                  />
                                </Form.Item>
                              </div>
                              <Form.Item
                                name="yearsOfExperience"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Years of Experience
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter years of experience",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>
                            <div className="grid md:grid-cols-2 gap-6">
                              <Form.Item
                                name="availability"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Availability
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select availability",
                                  },
                                ]}
                              >
                                <Select placeholder="Select Availability">
                                  {availabilityOptions.map((option) => (
                                    <Option key={option} value={option}>
                                      {option}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>

                              <Form.Item
                                name="education"
                                label={
                                  <span className="text-white">
                                    <span className="text-red-500">*</span>{" "}
                                    Education
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Please enter your education details",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>
                            <div className="grid md:grid-cols-2 gap-6">
                              <Form.Item
                                name="linkedinProfile"
                                label={
                                  <span className="text-white">
                                    Linkedin Profile (Optional)
                                  </span>
                                }
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="portfolio"
                                label={
                                  <span className="text-white">
                                    Portfolio/Website (Optional)
                                  </span>
                                }
                              >
                                <Input />
                              </Form.Item>
                            </div>
                            <Form.Item
                              name="keySkills"
                              label={
                                <span className="text-white">
                                  <span className="text-red-500">*</span> Key
                                  Skills (Comma-separated)
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter your key skills",
                                },
                              ]}
                            >
                              <TextArea rows={3} />
                            </Form.Item>
                            <Form.Item
                              name="coverLetter"
                              label={
                                <span className="text-white">
                                  Cover Letter (Optional)
                                </span>
                              }
                            >
                              <TextArea rows={5} />
                            </Form.Item>
                            <Form.Item
                              name="resume"
                              label={
                                <span className="text-white">
                                  <span className="text-red-500">*</span> Resume
                                </span>
                              }
                              valuePropName="fileList"
                              getValueFromEvent={normFile}
                              rules={[
                                {
                                  required: true,
                                  message: "Please upload your resume",
                                },
                              ]}
                            >
                              <div className="space-y-4">
                                <Upload
                                  name="resume"
                                  fileList={fileList}
                                  onChange={handleFileChange}
                                  beforeUpload={() => false}
                                  accept=".pdf,.doc,.docx"
                                  maxCount={1}
                                  onRemove={() => setFileList([])}
                                  showUploadList={{
                                    showRemoveIcon: true,
                                    removeIcon: (
                                      <DeleteOutlined
                                        style={{ color: "black" }}
                                        className="text-red-500 hover:text-red-700"
                                      />
                                    ),
                                  }}
                                >
                                  <Button icon={<UploadOutlined />}>
                                    Upload Resume
                                  </Button>
                                </Upload>

                                {/* File information */}
                                {fileList.length > 0 && (
                                  <div className="text-white text-sm">
                                    Current file: {fileList[0].name}
                                  </div>
                                )}

                                {/* Upload progress */}
                                {uploadProgress > 0 && uploadProgress < 100 && (
                                  <div className="text-white text-sm">
                                    Uploading: {uploadProgress}%
                                  </div>
                                )}

                                {/* File requirements */}
                                <div className="text-xs text-gray-300">
                                  Supported formats: PDF, DOC, DOCX (Max size:
                                  10MB)
                                </div>
                              </div>
                            </Form.Item>
                          </>
                        );
                      }

                      return null;
                    }}
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="w-full"
                      size="large"
                      loading={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>

            {/* Map */}
            <div
              data-aos="fade-left"
              className="h-[600px] rounded-lg overflow-hidden shadow-lg"
            >
              <iframe
                width="100%"
                height="600"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Unit%2012,%20Building%20B0051,%20ROAD%200402,%20AL%20QARYAH%200604,%20CAPITAL%20GOVERNORATE+(Solo%20Source)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              >
                <a href="https://www.gps.ie/collections/drones/">
                  drones ireland
                </a>
              </iframe>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="pb-20 ">
        <div className="container mx-auto px-6">
          <h2
            className="text-3xl font-bold text-white mb-12 text-center"
            data-aos="fade-up"
          >
            Frequently Asked Questions
          </h2>
          <div className="max-w-3xl mx-auto space-y-6">
            {[
              {
                question: "What are your business hours?",
                answer:
                  "We are open Monday through Friday, 9:00 AM to 6:00 PM (PST). Our support team is available 24/7 for urgent matters.",
              },
              {
                question: "How quickly can I expect a response?",
                answer:
                  "We typically respond to all inquiries within 24 hours during business days. For urgent matters, our response time is usually under 2 hours.",
              },
              {
                question: "Do you offer international services?",
                answer:
                  "Yes, we work with clients globally and have experience handling international projects across different time zones.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md p-6"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
